var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconCircleChevronRight = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 17"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 16,
  y: 0.5,
  fill: "#F2F0F0",
  rx: 8
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#999090",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.686,
  d: "m6.5 11.5 3-3-3-3"
})));
export default SvgIconCircleChevronRight;